<template>
  <div id="app">
    <div class="webapp-container">
      <notifs></notifs>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { pollIsOpen } from './router';
import FontService from '@/services/FontService';
import Notifs from '@/components/notifications/Notifs';
import { isEmpty } from 'ramda';

const searchParams = new URLSearchParams(window.location.search);
const pollId = searchParams.get('pollid');
const questionId = searchParams.get('questionid');

export default {
  name: 'app',
  components: {
    Notifs
  },
  computed: {
    ...mapGetters(['selectedPoll', 'activeQuestion'])
  },
  watch: {
    selectedPoll(poll) {
      // we want to redirect the user to the homepage
      // when he's inside a poll and we stop it
      if (!poll.isActive && !poll.isDisplayed && pollIsOpen(this.$route)) {
        this.$router.push({
          name: 'home'
        });
      }
      // incase current active question has been changed,
      // when question form opened,
      // navigate to new question
      const aq = this.activeQuestion;
      if (!isEmpty(aq) && 
          this.$router.currentRoute.name === 'questionContent' && 
          this.$router.currentRoute.params.questionId !== aq.questionId) {
        this.$router.replace({
          name: 'questionContent',
          params: {
            pollId: aq.pollId,
            questionId: aq.questionId
          }
        });
      }
    }
  },
  methods: {
    ...mapActions(['startPollingPolls', 'setDedicated', 'selectPoll'])
  },
  mounted() {
    FontService.load();

    if (pollId && questionId) {
      this.setDedicated(true);
      this.selectPoll(pollId).then(() => {
        this.$router.push({
        name: 'questionContent',
        params: {
          pollId,
          questionId
        }
      });
      })
    } else {
      this.startPollingPolls();
    }
  }
};
</script>

<style lang="scss">
:root {
  --box-shadow: 0 1px 3px rgb(226, 228, 234), 0 1px 2px rgb(239, 241, 247);
}

html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  // style is based on https://at-ui.github.io/at-ui/#/en/docs
  background-color: transparent;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  color: #3f536e;
  font-size: 14px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.break-word {
  word-break: break-word;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #2c405a;
}
h2 {
  font-size: 18px;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.webapp-container {
  padding: 20px;
  max-width: 600px;
  margin: auto;
  margin-bottom: 80px;
}
.card {
  background-color: #fff;
  box-shadow: 0 4px 30px 0 rgba(223, 225, 230, 0.5);
  padding: 30px;
  border-radius: 5px;
}
.list-entry {
  padding: 20px;
  border-radius: 5px;
  box-shadow: var(--box-shadow);
  cursor: pointer;
  margin-bottom: 10px;
  &:hover {
    background-color: #f7f9fb;
  }
}
</style>
